export default __webpack_public_path__ + "static/media/02.ebd57e90.jpg";